import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { BasicForm } from 'src/app/shared/basic-form';
import { setToLocalStorage } from 'src/app/shared/helpers';
import { AddPassengerFormComponent } from '../add-passenger-form/add-passenger-form.component';
import { AddPassengerComponent } from '../add-passenger/add-passenger.component';
import { ChoosePolicyComponent } from '../choose-policy/choose-policy.component';
import { ContactInfoComponent } from '../contact-info/contact-info.component';
import { FilledInfoComponent } from '../filled-info/filled-info.component';
import { InsuranceDaysComponent } from '../insurance-days/insurance-days.component';
import { InsuranePeriodComponent } from '../insurane-period/insurane-period.component';
import { PersonalInfoComponent } from '../personal-info/personal-info.component';
import { SuccessPageComponent } from '../success-page/success-page.component';
import { TravelerInfoComponent } from '../traveler-info/traveler-info.component';

@Component({
  selector: 'app-insurance-type',
  templateUrl: './insurance-type.component.html',
  styleUrls: ['./insurance-type.component.scss']
})
export class InsuranceTypeComponent extends BasicForm implements OnInit {

  oncearr = [];
  multiplearr = [];

  ngOnInit(): void {
    localStorage.removeItem('policyDraft');
    this.formAlias = 'InsuranceType';
    this.form = this.fb.group({
      type: ['', [Validators.required]]
    });
    this.form.patchValue(this.formData);
  }

  onSubmit() {
    setToLocalStorage('policy', this.formAlias, this.form.value);
    let value = { ...this.form.value };
    localStorage.setItem('type', value.type);
    if (value.type == 'once') {
      this.stepService.steps = [
        InsuranceTypeComponent,
        InsuranePeriodComponent,
        PersonalInfoComponent,
        ContactInfoComponent,
        ChoosePolicyComponent,
        AddPassengerComponent,
        AddPassengerFormComponent,
        TravelerInfoComponent,
        FilledInfoComponent,
        SuccessPageComponent
      ];
      this.stepService.nextStep();
    }
    if (value.type == 'multiple') {
      this.stepService.steps = [
        InsuranceTypeComponent,
        InsuranceDaysComponent,
        PersonalInfoComponent,
        ContactInfoComponent,
        ChoosePolicyComponent,
        FilledInfoComponent,
        SuccessPageComponent
      ]
      this.stepService.nextStep();
    }
    else {
      this.submitted = true;
    }
  }

}
